import Vue from 'vue';
import Guard1000Probes from '@/resources/guard-1000-probes';
import RootStateCommit from '@/store/mixins/rootstate-commit';
import normalize from '@/lib/normalize';

const DEFAULT_PROBES = {
  voltageProbes: {
    1: {
      connectionPoint: null,
      phase: null
    },
    2: {
      connectionPoint: null,
      phase: null
    },
    3: {
      connectionPoint: null,
      phase: null
    }
  },
  currentProbes: {
    1: {
      feederName: null,
      phase: null
    },
    2: {
      feederName: null,
      phase: null
    },
    3: {
      feederName: null,
      phase: null
    },
    4: {
      feederName: null,
      phase: null
    },
    5: {
      feederName: null,
      phase: null
    },
    6: {
      feederName: null,
      phase: null
    },
    7: {
      feederName: null,
      phase: null
    },
    8: {
      feederName: null,
      phase: null
    }
  }
};

const MODULE_NAME = 'guard1000Probes';
const DEFAULT_STATE = Object.freeze({
  data: DEFAULT_PROBES,
  error: null
});

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },
  /* eslint no-param-reassign: ["error", { "props": false }] */
  mutations: {
    parseResponseData(state, response) {
      const guardProbes = normalize(response.data);

      Vue.set(state, 'data', guardProbes);
    },
    setError(state, error) {
      Vue.set(state, 'error', error);
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    }
  },
  actions: {
    async fetchData({ commit }, params) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      commit('setError', null);

      const { projectCode, substationCode, externalGuardId } = params;

      try {
        const response = await Guard1000Probes({
          projectCode,
          substationCode,
          externalGuardId
        }).get();

        commit('parseResponseData', response);

        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      } catch (err) {
        commit('setError', err);

        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      }
    },
    async editGuardProbe({ commit }, params) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      commit('setError', null);

      const { projectCode, substationCode, externalGuardId, guardForm } = params;

      try {
        const response = await Guard1000Probes({
          projectCode,
          substationCode,
          externalGuardId
        }).update({ ...guardForm });

        commit('parseResponseData', response);

        RootStateCommit(commit, 'stopLoading', MODULE_NAME);

        return response.status;
      } catch (err) {
        commit('setError', err);

        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);

        return err.status;
      }
    }
  }
};
